var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 50,
    viewBox: "0 0 65 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.1739 40.5528C64.1739 40.2849 63.906 40.0165 63.6377 40.0165H59.0129V35.3917C59.0129 35.1238 58.745 34.8555 58.4766 34.8555H55.7285C55.4606 34.8555 55.1923 35.1234 55.1923 35.3917V40.0165H50.5675C50.2996 40.0165 50.0312 40.2844 50.0312 40.5528V43.3009C50.0312 43.5688 50.2991 43.8371 50.5675 43.8371H55.1923V48.4619C55.1923 48.7298 55.4602 48.9981 55.7285 48.9981H58.4766C58.7445 48.9981 59.0129 48.7303 59.0129 48.4619V43.8371H63.6377C63.9056 43.8371 64.1739 43.5692 64.1739 43.3009V40.5528Z",
    fill: "#43B02A",
    stroke: "#43B02A",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2346 39.4727H1.03625C0.76836 39.4727 0.5 39.7405 0.5 40.0089V43.6954C0.5 43.9632 0.767894 44.2316 1.03625 44.2316H13.2346C13.5025 44.2316 13.7709 43.9637 13.7709 43.6954V40.0089C13.7709 39.7405 13.503 39.4727 13.2346 39.4727Z",
    fill: "#43B02A",
    stroke: "#43B02A",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7832 24.8477H10.4187V29.9414H3.7832V24.8477Z",
    fill: "#43B02A",
    stroke: "#43B02A",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0977 30.6827H21.1404V19.3555H13.0977V30.6827ZM14.5049 20.8301H19.6659V29.275H14.5049V20.8301Z",
    fill: "#43B02A",
    stroke: "#43B02A",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0859 30.6834H31.1287V14.5977H23.0859V30.6834ZM24.4937 16.0052H29.6547V29.2759H24.4937V16.0052Z",
    fill: "#43B02A",
    stroke: "#43B02A",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8105 30.0151H40.446V10.5781H33.8105V30.0151ZM35.2178 11.9856H38.971V28.6076H35.2178V11.9856Z",
    fill: "#43B02A",
    stroke: "#43B02A",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.366 5.75781H43.7305V30.0205H50.366V5.75781ZM48.9582 28.546H45.205V7.16532H48.9582V28.546Z",
    fill: "#43B02A",
    stroke: "#43B02A",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3543 1H53.7188V30.0214H60.3543V1ZM58.947 28.5469H55.1938V2.40751H58.947V28.5469Z",
    fill: "#43B02A",
    stroke: "#43B02A",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.df3860f9460456c793c0f9d6caa9f429.svg";
export { ForwardRef as ReactComponent };